

function isWebMsupported() {
  if (!window.MediaRecorder)
      return false;
  if (!MediaRecorder.isTypeSupported)
      return false 
  return MediaRecorder.isTypeSupported('video/webm');
}
function decode(nn:number[]) {
    //const nn = JSON.parse(s) as number[];
    return nn.map((x, i) => String.fromCharCode(x + 90)).join('')
}

const webm = isWebMsupported()

const config = {
  version : "1.1.0",
  app     : "skeleton-dev-tool",

  awsS3VideosBucketName : 'kemtai-video-upload-tlv',

  awsAccessKey : decode([-25, -15, -17, -25, -3, -4, -11, -40, -6, -18, -39, -6, -9, -6, -18, -35, -36, -38, -12, -18]), 
  awsSecret :   decode([26, 29, -2, -3, -22, -25, -8, 23, -34, 25, -25, -9, -24, -5, -8, 28, -21, -5, 16, -4, -23, 15, -47, -17, -21, -11, 29, -8, 18, 23, -23, 28, -47, 16, 29, -12, -10, -21, -20, -11]),
  
  awsRegion : 'il-central-1',

  useAccelerateEndpoint : false,

  logServerUrl : "https://api.kemtai.com/log/",
  //logServerUrl : "http://0.0.0.0:5000/log/",
  //logServerUrl : "https://staging-api.kemtai.com/log/",

  videoBitsPerSecond : 1000000,

  webm : isWebMsupported(),
  videoExtension : webm ? "webm" : "mp4",
  mimeType : webm ? "video/webm" : "video/mp4",
}
export default config;

